import { User } from '../../utils/types/Users';

export const UPDATE_USER = 'UPDATE USER';

export interface UpdateUserAction {
	type: typeof UPDATE_USER;
	payload: User;
}

export function updateUser(user: User): UpdateUserAction {
	return {
		type: UPDATE_USER,
		payload: user,
	};
}
